import checkFF from '@webapp-next/lib/feature-flag';
import { createWebappRoute, getCurrentRoutePath } from '../helpers';

export default [
  createWebappRoute({
    path: '/profile',
    name: 'profile-module',
    component() {
      console.log('ROUTER profile');
      const path = getCurrentRoutePath();

      if (checkFF('ptp-0-profile-vue')) {
        VueEventBus.$emit(VueEvents.PROFILE.PROFILE_SHOW, path);

        return;
      }

      $dt.rtrMEGoto = path || '/home';
      return {};
    },
  }),
];
